<template>
    <main class="mt-5">
        <span id="add-btn">
            <router-link
                :to="'/admin/havale/create'"
                class="btn btn-success"
            >
            حواله بین انبار جدید
            </router-link>
        </span>
        <b-tooltip v-if="!hasPermission('write_store')" target="add-btn" triggers="hover">
            شما به این بخش دسترسی ندارید
        </b-tooltip>
        <div class="card mt-3">
            <div class="card-header  border-0">
                <h5 class="card-title font-bold">حواله های بین انبار</h5>
                <div style="flex:1"></div>
                <b-button
                    class="ml-2"
                    v-if="btnStatus"
                    variant="light"
                    v-b-modal.change-status
                >
                تغییر وضعیت
                </b-button>
                <b-button
                    class="ml-2"
                    v-if="btnStatus"
                    variant="info"
                    @click="printVarieties"   
                >
                پرینت
                </b-button>
                <b-button
                    v-b-toggle.filter
                    :variant="hasFilter() ? 'secondary' : 'primary'"
                    >
                    <span class="fe fe-search pt-1" style="font-size: 17px"></span>
                </b-button>
            </div>
            <b-collapse id="filter" class="mt-2 mx-5">
                <b-card>
                    <form @submit.prevent="filterItem()">
                        <div class="row mt-5">
                            <b-form-group class="col-md-4">
                                <multiselect
                                v-if="!$root.isEmptyObject(stores)"
                                placeholder="انبار مبدا"
                                v-model="filter.from_store_id"
                                open-direction="bottom"
                                :options="stores"
                                label="label"
                                track-by="id"
                                :searchable="true"
                                :close-on-select="true"
                                :show-labels="false"
                                :disabled="disabled"
                                >
                                <template slot="noOptions"> موردی یافت نشد </template>
                                <template slot="noResult"> موردی یافت نشد </template>
                                </multiselect>
                            </b-form-group>
                            <b-form-group class="col-md-4">
                                <multiselect
                                v-if="!$root.isEmptyObject(stores)"
                                placeholder="انبار مقصد"
                                v-model="filter.to_store_id"
                                open-direction="bottom"
                                :options="stores"
                                label="label"
                                track-by="id"
                                :searchable="true"
                                :close-on-select="true"
                                :show-labels="false"
                                :disabled="disabled"
                                >
                                <template slot="noOptions"> موردی یافت نشد </template>
                                <template slot="noResult"> موردی یافت نشد </template>
                                </multiselect>
                            </b-form-group>
                            <b-form-group class="col-md-4">
                                <multiselect
                                placeholder="وضعیت"
                                v-model="filter.status"
                                open-direction="bottom"
                                :options="statusOptions"
                                label="name"
                                track-by="value"
                                :searchable="true"
                                :close-on-select="true"
                                :show-labels="false"
                                :disabled="disabled"
                                >
                                <template slot="noOptions"> موردی یافت نشد </template>
                                <template slot="noResult"> موردی یافت نشد </template>
                                </multiselect>
                            </b-form-group>
                            <b-form-group class="col-md-4">
                                <date-picker placeholder="از تاریخ" v-model="filter.start_date" format="YYYY-MM-DD"
                                    display-format="jYYYY-jMM-jDD" />
                            </b-form-group>
                            <b-form-group class="col-md-4">
                                <date-picker ref="endPicker" placeholder="تا تاریخ" v-model="filter.end_date" format="YYYY-MM-DD"
                                    display-format="jYYYY-jMM-jDD" />
                            </b-form-group>
                            </div>
                            <div class="text-center mt-6">
                            <button
                                :disabled="disabled"
                                type="submit"
                                class="btn btn-primary px-5"
                            >
                                جستجو
                            </button>
                            <button
                                :disabled="disabled"
                                @click="resetFilter"
                                class="btn btn-warning px-5 mr-3"
                            >
                                برداشتن فیلتر
                            </button>
                            <button
                                :disabled="disabled"
                                @click="$root.$emit('bv::toggle::collapse', 'filter')"
                                class="btn btn-secondary px-5 mr-3"
                            >
                                بستن
                            </button>
                        </div>
                    </form>
                </b-card>
            </b-collapse>
            <div class="card-body">
                <div>
                    <b-table responsive hover bordered :items="items.data" :fields="fields">
                    <template v-slot:cell(index)="data">
                        {{ data.index + 1}}
                    </template>
                                <template #head(select)="row">
              <b-form-checkbox
                :disabled="items == null"
                class="text-center text-dark"
                :id="'checkbox-all' + row.label"
                name="checkboxall"
                @change="havaleSelectAll"
                v-model="allSelected"
              >
              </b-form-checkbox>
            </template>
                    <template #cell(select)="row">
                        <b-form-checkbox
                            :disabled="row.item.status == 'rolled_back'"
                            class="text-center text-dark table-checkbox"
                            :notselected="!selectedHavale[row.index]"
                            :selected="selectedHavale[row.index]"
                            :id="'checkbox' + row.item.id"
                            :name="'checkbox' + row.item.id"
                            @change="havaleSelect(row.index, row.item.id)"
                        >
                        </b-form-checkbox>
                    </template>
                    <template v-slot:cell(created_at)="data">
                        {{ data.item.created_at | persianDate}}
                    </template>
                    <template v-slot:cell(status)="data">
                        <span
                            v-if="data.item.status === 'new'"
                            class="badge badge-primary status"
                            >در انتظار تکمیل</span
                        >
                        <span
                            v-else-if="data.item.status === 'in_progress'"
                            class="badge badge-secondary status"
                            >در حال پردازش</span
                        >
                        <span
                            v-else-if="data.item.status === 'sent'"
                            class="badge badge-success status"
                            >ارسال شده</span
                        >
                        <span
                            v-else-if="data.item.status === 'rolled_back'"
                            class="badge badge-danger status"
                            >لغو شده</span
                        >
                    </template>
                    <template v-slot:cell(show)="data">
                        <router-link
                            :to="'/admin/havale/show/' + data.item.id"
                            class="action-btns1 pt-1 px-1"
                            >
                            <i
                                style="vertical-align: text-top"
                                class="fe fe-eye text-primary"
                            ></i>
                        </router-link>
                    </template>
                    </b-table>
                    <Loading v-if="$root.isEmptyObject(items)" />
                    <pagination v-else-if="items.data != ''" :disabled="disabled" :limit="2" :data="items"
                    @pagination-change-page="changePage">
                    </pagination>
                    <div v-if="$root.isEmptyObject(items)" class="alert alert-danger">
                    موردی یافت نشد
                    </div>
                </div>
            </div>
        </div>

        <b-modal id="change-status" hide-footer title="تغییر وضعیت">
            <form @submit.prevent="updateStatus()">
            <b-form-group>
                <multiselect
                placeholder="وضعیت"
                v-model="havaleStatus"
                open-direction="bottom"
                :options="editStatus"
                label="name"
                track-by="value"
                :searchable="true"
                :close-on-select="true"
                :show-labels="false"
                :disabled="disabled"
                >
                <template slot="noOptions">
                    موردی یافت نشد
                </template>
                <template slot="noResult">
                    موردی یافت نشد
                </template>
                </multiselect>
            </b-form-group>
            <div class="text-center mt-3">
                <button class="btn btn-primary" :disabled="disabled">ویرایش</button>
            </div>
            </form>
        </b-modal>
    </main>
</template>
<script>
import HavaleLpml from '@@/core/pages/Havale/HavaleLpml'
export default {
    extends : HavaleLpml
}
</script>